module.exports = __webpack_public_path__ + "img/part2.2e42829e.png";